import { httpCreate } from './http';

const http = httpCreate('/srv/activityScreenMax');

export const activityScreenMax = {
	// 直播间扩容信息
	getExpanInfo(activityId) {
		return http.get(`/getInfo/${activityId}`);
	},
	// 获取价格信息
	getPrice(activityId) {
		return http.get(`/getPrice/${activityId}`);
	},
	// 修改扩容时间
	fixExpanTime(activityId, params) {
		return http.put(`/${activityId}`, params);
	},
};
